'use client';

import { c as _c } from "react/compiler-runtime";
import { ErrorBoundary } from '@svenskaspelab/poolbetting/core/nextjs/lib/client';
import { AsideSideNav } from '@svenskaspelab/poolbetting/ui/Layout';
import { useMediaQueryAbove } from '@svenskaspelab/ui/media-query/react';
import { type PropsWithChildren, type ReactNode, Suspense } from 'react';
import SideNavError from './SideNavError';
import SideNavLoading from './SideNavLoading';
type SideNavProps = PropsWithChildren;

/**
 * Sidenav component.
 *
 * @param root0 Component props
 * @param root0.children Children components to render
 * @returns Sidenav component
 */
export default function SideNav(t0) {
  const $ = _c(3);
  const {
    children
  } = t0;
  const isDesktop = useMediaQueryAbove("md");
  if (!isDesktop) {
    return;
  }
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <SideNavLoading />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== children) {
    t2 = <AsideSideNav><ErrorBoundary Fallback={SideNavError}><Suspense fallback={t1}>{children}</Suspense></ErrorBoundary></AsideSideNav>;
    $[1] = children;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}